import React from 'react';
import styled from 'styled-components';
import { Modal, Button } from '@prosolve/common-components-ui'
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import CopyUrlButton from './CopyUrlButton';
import { downloadAssetFile } from './downloadUtils';
import { formatBytes, isImageFile } from './fileTypeUtils';

const PreviewArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #f5f5f5;
  border-radius: 5px;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 55vh;
    object-fit: contain;
  }

  iframe {
    width: 100%;
    height: 55vh;
    border: none;
  }
`

const UrlRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`

const UrlText = styled.div`
  flex: 1;
  padding: 8px 10px;
  background: #f3fbff;
  border: 1px solid #dedede;
  border-radius: 5px;
  font-size: 13px;
  color: #565656;
  word-break: break-all;
`

export default ({
  file,
  onClose
}) => {
  const isImage = isImageFile(file.name);
  const isPdf = /\.pdf$/i.test(file.name || '');

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={() => downloadAssetFile(file)}>
        <span style={{ display: 'inline-flex', alignItems: 'center', columnGap: '5px' }}>
          <FiDownload />
          {'Download'}
        </span>
      </Button>
      <Button onClick={() => window.open(file.url, '_blank', 'noopener')}>
        <span style={{ display: 'inline-flex', alignItems: 'center', columnGap: '5px' }}>
          <FaExternalLinkAlt />
          {'Open in New Tab'}
        </span>
      </Button>
      <Button onClick={onClose}>
        {'Close'}
      </Button>
    </div>
  )

  return (
    <Modal title={file.name} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
        <PreviewArea>
          {isImage && <img src={file.url} alt={file.name} />}
          {isPdf && <iframe src={file.url} title={file.name} />}
          {!isImage && !isPdf && (
            <div style={{ color: '#7e7e7e', textAlign: 'center', padding: '20px' }}>
              <div style={{ fontWeight: 'bold' }}>{file.name}</div>
              <div style={{ fontSize: '13px', marginTop: '5px' }}>{formatBytes(file.size)}</div>
              <div style={{ fontSize: '13px', marginTop: '10px' }}>{'No preview available for this file type.'}</div>
            </div>
          )}
        </PreviewArea>
        <UrlRow>
          <UrlText>{file.url}</UrlText>
          <CopyUrlButton url={file.url} />
        </UrlRow>
      </div>
    </Modal>
  )
}
